import { useStore } from "@stores";
import { useEffect, useState } from "react";

export const useAnnouncements = () => {
  const { announcementStore } = useStore();
  const { loading, announcements, skipCount, maxResultCount, totalCount } =
    announcementStore;

  const [keyword, setKeyword] = useState<string | undefined>(undefined);

  useEffect(() => {
    announcementStore.getAll({
      skipCount,
      maxResultCount,
      keyword,
    });
  }, [announcementStore, skipCount, maxResultCount, keyword]);

  const handleSearch = (value: string) => {
    setKeyword(value || undefined);
    announcementStore.setSkipCount(0);
  };

  return {
    announcements,
    loading,
    totalCount,
    maxResultCount,
    currentPage: Math.floor(skipCount / maxResultCount) + 1,
    handlePageChange: announcementStore.handlePageChange,
    handleSearch,
  };
};
